import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ShowAllCategories } from "../../../../context/Slice/VendorManagementSlice";
import { ShowAllServiceLocation } from "../../../../context/Slice/VendorManagementSlice";
import { Box, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import "../Top-Wedding-Listings/WeddingListings.css";

const BackEnd_URL = process.env.REACT_APP_BASE_URL;

// Parse image URL function
const getImagePath = (categorieImage) => {
  try {
    let imagePaths = [];

    // Check if categorieImage is a stringified JSON
    if (typeof categorieImage === "string") {
      try {
        const parsedImage = JSON.parse(categorieImage);

        // Ensure it's an array and contains valid paths
        if (Array.isArray(parsedImage)) {
          imagePaths = parsedImage.map(
            (path) =>
              `${BackEnd_URL}${path.replace("/home/CEP_BackEnd", "")}` 
          );
          return imagePaths; // Return transformed array
        }
      } catch (e) {
        console.error("Error parsing CategorieImage:", e);
        return null; // Return null if parsing fails
      }
    } else if (Array.isArray(categorieImage)) {
      // Already an array, apply the transformation directly
      imagePaths = categorieImage.map(
        (path) =>
          `${BackEnd_URL}${path.replace("/home/CEP_BackEnd", "")}` 
      );
      return imagePaths; // Return transformed array
    }

    return null; // Return null if no valid image paths found
  } catch (error) {
    console.error("Unexpected error in getImagePath:", error);
    return null;
  }
};

const Recommendation = ({ id }) => {
  const [vendors, setVendors] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const categories = useSelector((state) => state.VendorManagementR.AllCat);
  const locations = useSelector((state) => state.VendorManagementR.AllLoc);
  const [selectedBadges, setSelectedBadges] = useState("All");
  const [selectedCities, setSelectedCities] = useState("All");
  const [selectedService, setSelectedService] = useState("All");
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);

  useEffect(() => {
    setServiceOptions([
      "All",
      ...(categories || []).map((cat) => cat.CategorieName),
    ]);
    setCityOptions([
      "All",
      ...(locations || []).map((loc) => loc.LocationName),
    ]);
  }, [categories, locations]);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${BackEnd_URL}/api/v1/CoordinatorManagement/show-CoordinatorDetail/${id}`
        );

        // Extract CoordinatorDetail recommendation
        let vendors =
          response.data?.data?.CoordinatorDetail?.[0]?.recommendation;

        // Parse JSON if vendors is a string
        if (typeof vendors === "string") {
          try {
            vendors = JSON.parse(vendors);
            console.log(vendors);
          } catch (error) {
            console.error("Error parsing JSON:", error);
            vendors = []; // Fallback to empty array
          }
        }

        // Ensure vendors is an array
        if (!Array.isArray(vendors)) {
          console.error("Unexpected data format for recommendation:", vendors);
          vendors = [];
        }

        // Filter vendors with status "approved"
        const filteredVendors = vendors
        

        // Allowed service names
        const allowedServiceNames = [
          "PHOTOGRAPHERS",
          "VENUE",
          "MEHANDI ARTIST",
          "DECORATORS",
          "WEDDING CATERERS",
          "MAKEUP ARTISTS",
        ];

        // Process vendors with allowed service names
        const parsedData = filteredVendors
          .filter((vendor) => allowedServiceNames.includes(vendor.ServiceName))
          .map((vendor) => ({
            ...vendor,
            SpecialBadges:
              vendor.SpecialBadges && typeof vendor.SpecialBadges === "string"
                ? JSON.parse(vendor.SpecialBadges)
                : [], // Ensure SpecialBadges is an array
          }));

        // Collect unique service names
        const uniqueServiceNames = [
          ...new Set(parsedData.map((vendor) => vendor.ServiceName)),
        ];

        setVendors(parsedData);
        setFilteredVendors(parsedData);

        console.log("Filtered Vendors:", parsedData);
        console.log("Unique Service Names:", uniqueServiceNames);
      } catch (error) {
        console.error("Error fetching vendor services:", error);
        setVendors([]);
      } finally {
        setLoading(false);
      }
    };

    fetchVendors();
  }, [id]);
  // Added `id` to dependencies to avoid stale data

  useEffect(() => {
    dispatch(ShowAllCategories());
  }, [dispatch]);

  useEffect(() => {
    dispatch(ShowAllServiceLocation());
  }, [dispatch]);

  const handleViewDetails = (vendor) => {
    // Get the token from local storage
    const token = localStorage.getItem("token");

    if (token) {
      try {
        // Decode the JWT token
        const decodedToken = jwtDecode(token);

        // Extract the role from the decoded token
        const role = decodedToken.role;

        // Save the role to localStorage
        localStorage.setItem("role", role);
        console.log("Role extracted from token:", role);

        if (vendor.ServiceCategory_ID) {
          localStorage.setItem("ServiceCategory_ID", vendor.ServiceCategory_ID);
          console.log("Stored ServiceCategory_ID:", vendor.ServiceCategory_ID);
        }

        // Check if the role is valid
        const allowedRoles = ["USER", "ADMIN", "VENDOR", "CO-ORDINATOR"];
        if (allowedRoles.includes(role)) {
          navigate(`/vendor-details/${vendor.Vendor_ID}`);
        } else {
          setShowLoginPopup(true); // Show login popup if role is not valid
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setShowLoginPopup(true); // Show login popup if token is invalid
      }
    } else {
      setShowLoginPopup(true); // Show login popup if no token
    }
  };
  const handleLoginRedirect = () => {
    setShowLoginPopup(false); // Close the popup
    navigate("/login"); // Redirect to the login page
  };

  const handleServiceChange = (event) => {
    const value = event.target.value;
    setSelectedService(value);

    if (value === "All") {
      // Reset vendors and show all cities
      setFilteredVendors(vendors);
      setCityOptions([
        "All",
        ...new Set(locations.map((loc) => loc.LocationName)),
      ]);
      setSelectedCities("All"); // Reset city selection
    } else {
      // Filter vendors by selected service
      const filteredByService = vendors.filter(
        (vendor) => vendor.ServiceName === value
      );

      // Update city options dynamically based on filtered vendors
      const citiesWithVendorsForService = filteredByService.map(
        (vendor) => vendor.City
      );
      const uniqueCitiesForService = [
        "All",
        ...new Set(citiesWithVendorsForService),
      ];

      setFilteredVendors(filteredByService);
      setCityOptions(uniqueCitiesForService);
      setSelectedCities("All"); // Reset city selection
    }
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setSelectedCities(value);

    if (value === "All") {
      // Reset vendors and show all categories
      setFilteredVendors(vendors);
      setServiceOptions([
        "All",
        ...new Set(categories.map((cat) => cat.CategorieName)),
      ]);
      setSelectedService("All"); // Reset service selection
    } else {
      // Filter vendors by selected city
      const filteredByCity = vendors.filter((vendor) =>
        vendor.City.includes(value)
      );

      // Update service options dynamically based on filtered vendors
      const categoriesWithVendorsForCity = filteredByCity.map(
        (vendor) => vendor.ServiceName
      );
      const uniqueCategoriesForCity = [
        "All",
        ...new Set(categoriesWithVendorsForCity),
      ];

      setFilteredVendors(filteredByCity);
      setServiceOptions(uniqueCategoriesForCity);
      setSelectedService("All"); // Reset service selection
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      <section id="wed-list" className="wed-list">
        <div className="container">
          <div className="row align-items-center">
            <div className="centered-container">
              <h2
                className="section-heading"
                data-aos="zoom-in-down"
                data-aos-delay="100"
                data-aos-duration="900"
              >
                Recommended for You{" "}
              </h2>
              <p
                className="section-para text-border"
                data-aos="zoom-in-up"
                data-aos-delay="150"
                data-aos-duration="900"
              >
                Handpicked vendors based on your preferences, budget, and
                location.
              </p>
              <Box sx={{ mt: "40px", display: "flex", gap: 2 }}>
                <FormControl
                  className="filter-dropdown"
                  style={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)", // Subtle shadow
                  }}
                >
                  <InputLabel
                    style={{ color: "#1976d2", fontWeight: "bolder" }}
                  >
                    Cities
                  </InputLabel>
                  <Select
                    value={selectedCities}
                    onChange={handleCityChange}
                    label="Filter by Cities"
                    style={{ fontWeight: "bold", color: "#333" }}
                  >
                    {cityOptions.map((service, index) => (
                      <MenuItem key={index} value={service}>
                        {service}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl
                  className="filter-dropdown"
                  style={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)", // Subtle shadow
                  }}
                >
                  <InputLabel
                    style={{ color: "#1976d2", fontWeight: "bolder" }}
                  >
                    Categories
                  </InputLabel>
                  <Select
                    value={selectedService}
                    onChange={handleServiceChange}
                    label="Filter by Service"
                    style={{ fontWeight: "bold", color: "#333" }}
                  >
                    {serviceOptions.map((service, index) => (
                      <MenuItem key={index} value={service}>
                        {service}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>

          <div className="row align-items-center">
            {filteredVendors.slice(0, 5).map((vendor, index) => (
              <div
                key={index}
                className="col"
                data-aos="zoom-in"
                data-aos-delay="300"
                data-aos-easing="ease-in-sine"
              >
                <div className="card">
                  <div className="image-container">
                    {/* Banner Image */}
                    <img
                      src={getImagePath(vendor.BannerImage)}
                      className="img-fluid rounded thumbnail-image"
                      alt="vendor_card"
                    />
                  </div>
                  <div className="product-detail-container p-3">
                    <div
                      className="d-flex justify-content-between  align-items-center"
                      style={{ flexWrap: "wrap" }}
                    >
                      <h5 className="product-name">
                        {/* {vendor.Vendor.firstName} */}
                      </h5>
                      <div className="d-flex flex-column mb-2">
                        <span className="new-price">
                          Budget: {vendor.TotalBudget}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="new-service">
                        Service: {vendor.ServiceName}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pt-1">
                      <div>
                        {/* Special Badges */}
                        {vendor.SpecialBadges &&
                        vendor.SpecialBadges.length > 0 ? (
                          <div className="special-badges">
                            {vendor.SpecialBadges.map((badge, index) => (
                              <span key={index} className="badge">
                                {badge}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span>No Badges</span>
                        )}
                      </div>
                      {/* View Details Button */}
                      <button
                        className="btn btn-primary premium-vendor-btn"
                        onClick={() => handleViewDetails(vendor)}
                      >
                        View
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {showLoginPopup && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <p>To know the vendor details, please do log in first.</p>
                  <button
                    className="btn btn-primary"
                    onClick={handleLoginRedirect}
                  >
                    Login
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Recommendation;
